import { Component, input } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatProgressBar } from '@angular/material/progress-bar';

export type spinnerType =
  | 'spinnerDeterminate'
  | 'spinnerIndeterminate'
  | 'progressBarDeterminate'
  | 'progressbarIndeterminate'
  | 'progressbarDeterminate'
  | 'progressbarBuffer';

@Component({
  selector: 'app-sb-spinner',
  imports: [MatProgressSpinner, MatProgressBar],
  templateUrl: './sb-spinner.component.html'
})
/**
 * Begründung: Der Spinner ist keine Anforderung der Gematik, wurde aber für die Userexperience eingebaut
 */
export class SbSpinnerComponent {
  type = input<spinnerType>();
  diameter = input<number>();
  progress = input<() => void>();
  bufferProgress = input<() => void>();
  height = input<string>();
  width = input<string>();
}
